/* eslint-disable no-unused-vars */
import {useEffect, useRef} from "react";
import clsx from "clsx";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {Formik} from "formik";
import {SubmitButton} from "components/Button";
import {useToast} from "hooks/useToast";
import {convertErrorMessageFormat} from "utils/converter";
import {useEditActionCategory, useDetailActionCategory} from "hooks/SuperAdmin/ActionCategory";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useParams} from "react-router-dom";

const FormSchemaValidation = Yup.object().shape({
	title: Yup.string().required("Nama kategori tindakan wajib di isi"),
});
const FormInitialValues = {title: ""};

export function ActionCategoryEditPage() {
	const {showToast} = useToast();
	const formikRef = useRef();
	const history = useHistory();
	const params = useParams();
	const {id} = params;
	const {isLoading: loadingFetcing, error, isError, data: detailActionCategory} = useDetailActionCategory(id);
	const {mutate, isLoading: isSubmitting} = useEditActionCategory();
	const handleSubmit = formData => {
		mutate(
			{id, ...formData},
			{
				onSuccess: () => {
					showToast("success", "Data berhasil diperbarui");
					history.push("/kategori-tindakan");
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	useEffect(() => {
		if (detailActionCategory) formikRef.current.setFieldValue("title", detailActionCategory?.data?.title);
	}, [detailActionCategory]);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard title="Edit Kategori Tindakan">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<Formik
				initialValues={FormInitialValues}
				innerRef={formikRef}
				validationSchema={FormSchemaValidation}
				onSubmit={handleSubmit}>
				{({handleSubmit, handleBlur, handleChange, values, errors}) => (
					<FormCard
						backTitle="Daftar List Kategori Tindakan"
						title="Edit Kategori Tindakan"
						onBackButtonClick={() => history.push("/kategori-tindakan")}>
						<div class="row gx-2 mb-5">
							<div class="col-sm-6 col-6">
								<div class="setting-item">
									<label class="setting-label required">Nama Kategori Tindakan</label>
									<input
										class={clsx("form-control", errors?.title && "form-control-error")}
										disabled={isSubmitting}
										name="title"
										placeholder=""
										type="text"
										value={values?.title}
										onBlur={handleBlur}
										onChange={handleChange}
									/>
									{errors.title && <p className="form-error-item-message">{errors.title}</p>}
								</div>
							</div>
						</div>

						<div class="text-center my-3">
							<SubmitButton
								className="btn btn-orange d-inline-block mw-250"
								disabled={!FormSchemaValidation.isValidSync(values)}
								loading={isSubmitting}
								text="Simpan Perubahan"
								onClick={handleSubmit}
							/>
						</div>
					</FormCard>
				)}
			</Formik>
		</DashboardLayout>
	);
}
